/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_No_Plan_TitleInputs */

const en_us2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have a plan yet`)
};

const pt_br2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não tem um plano`)
};

const es_419_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no tienes un plan`)
};

const pt_pt2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não tens um plano`)
};

const fr_fr2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as pas encore de programme`)
};

const de_de2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast noch keinen Plan`)
};

const it_it2_workout_no_plan_title = /** @type {(inputs: Workout_No_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai ancora una scheda`)
};

/**
* | output |
* | --- |
* | "You don't have a plan yet" |
*
* @param {Workout_No_Plan_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_no_plan_title = /** @type {((inputs?: Workout_No_Plan_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_No_Plan_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_no_plan_title(inputs)
	if (locale === "es-419") return es_419_workout_no_plan_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_no_plan_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_no_plan_title(inputs)
	if (locale === "de-DE") return de_de2_workout_no_plan_title(inputs)
	if (locale === "it-IT") return it_it2_workout_no_plan_title(inputs)
	return en_us2_workout_no_plan_title(inputs)
});
export { workout_no_plan_title as "workout.no_plan_title" }